// extracted by mini-css-extract-plugin
export var tooltip = "tooltip-module--tooltip--cd6ad";